import React, { Suspense, useEffect, useState, lazy } from "react";

// Libraries
import { Routes, Route, useLocation } from "react-router-dom";
import retina from "retinajs";
import { AnimatePresence } from "framer-motion";

// Context
import GlobalContext from "./Context/Context";

// Components
import ScrollToTopButton from "./Components/ScrollToTop";
import CustomRedirectFCE from "./Components/CustomRedirectFCE";


// Pages
const DigitalagencyPage = lazy(() => import("./Pages/Home/DigitalAgency"));
const PortfolioBoxedMetroPage = lazy(() =>
  import("./Pages/Portfolios/PortfolioBoxed/PortfolioBoxedMetro")
);
const ContactUsClassicPage = lazy(() =>
  import("./Pages/Contact/ContactUsClassicPage")
);
const WhatWeOfferPage = lazy(() => import("./Pages/Services/WhatWeOfferPage"));
// const EmptyPage = lazy(() => import("./Pages/Custom/EmptyPage"));
const Privacy = lazy(() => import("./Pages/Custom/Privacy"));
const Terms = lazy(() => import("./Pages/Custom/Terms"));
const NotFoundPage = lazy(() => import("./Pages/404"));
// const BlogSideImgPage = lazy(() => import("./Pages/Blogs/BlogSideImg"));
const BlogPostLayoutYa = lazy(() => import("./Pages/Blogs/LayoutPage/BlogPostLayoutYa"));
const LeftSidebar = lazy(() => import("./Pages/Shop/LeftSideBar"));
const OnlyCategories = lazy(() => import("./Pages/Shop/OnlyCategories"));
const ShopWidePage = lazy(() => import("./Pages/Shop/ShopWide"));
const EditorPage = lazy(() => import("./Pages/Custom/EditorPage"));

function App() {
  const [headerHeight, setHeaderHeight] = useState(0);
  const [footerHeight, setFooterHeight] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [customModal, setCustomModal] = useState({
    el: null,
    isOpen: false,
  });
  const location = useLocation();

  //  #e6994e
  // #0038e3
  const baseColor = "#0038e3";

  // RetinaJS
  useEffect(() => {
    window.addEventListener("load", retina(document.querySelectorAll("img")));
  }, []);

  useEffect(() => {
    setTimeout(() => {
      import("./Functions/Utilities").then((module) => {
        module.SetHeaderMenuPos();
        module.setDocumentFullHeight();
      });
    }, 1000);
  }, [location]);

  useEffect(() => {
    if (isModalOpen === true) {
      document.querySelector("body").classList.add("overflow-hidden");
    } else {
      document.querySelector("body").classList.remove("overflow-hidden");
    }
  }, [isModalOpen]);

  // Get the current location and set the window to top
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
    setFooterHeight(0);
    setCustomModal({
      ...customModal,
      el: null,
      isOpen: false,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <GlobalContext.Provider
      value={{
        headerHeight,
        setHeaderHeight,
        footerHeight,
        setFooterHeight,
        isModalOpen,
        setIsModalOpen,
        customModal,
        setCustomModal,
      }}
    >
      <div className="App" style={{ "--header-height": `${headerHeight}px` }}>
        {
          <main style={{ marginTop: headerHeight, marginBottom: footerHeight }}>
            <ScrollToTopButton />
            <AnimatePresence mode="wait">
              <Suspense fallback={<></>}>
                <Routes>

                  <Route
                    path="/"
                    element={
                      <DigitalagencyPage

                        style={{ "--base-color": baseColor }}
                      />
                    }
                  />
                  <Route
                    path="/portfolio"
                    element={
                      <PortfolioBoxedMetroPage
                        style={{ "--base-color": baseColor }}
                      />
                    }
                  />
                  <Route
                    path="/media"
                    element={
                      <WhatWeOfferPage style={{ "--base-color": baseColor }} />
                    }
                  />
                  {/* <Route
                    path="/fitcropedit"
                    element={
                      <EditorPage style={{ "--base-color": baseColor }} />
                    }
                  /> */}
                  <Route
                    path="/fitcropedit"
                    element={
                      <CustomRedirectFCE />
                    }
                  />
                  <Route
                    path="/knowledge"
                    element={
                      <BlogPostLayoutYa style={{ "--base-color": baseColor }} />
                    }
                  />
                  <Route
                    path="/contact"
                    element={
                      <ContactUsClassicPage
                        style={{ "--base-color": baseColor }}
                      />
                    }
                  />
                  <Route
                    path="/privacy"
                    element={
                      <Privacy
                        style={{ "--base-color": baseColor }}
                      />
                    }
                  />
                  <Route
                    path="/terms"
                    element={
                      <Terms
                        style={{ "--base-color": baseColor }}
                      />
                    }
                  />
                  {/* <Route path="/catalog" element={<LeftSidebar  style={{ "--base-color": baseColor }}/>} /> */}
                  <Route path="/catalog" element={<OnlyCategories style={{ "--base-color": baseColor }} />} />
                  <Route path="/catalog/:slug" element={<ShopWidePage />} />

                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </Suspense>
            </AnimatePresence>
          </main>
        }
      </div>
    </GlobalContext.Provider>
  );
}

export default App;
